/** Recordings only. Surge XT is an offline authoring tool, never an app dependency. */
export const STUDIO_SYNTH_LIBRARY = {
  "id": "cookup-studio-synths",
  "name": "CookUp Studio Synths",
  "version": 1,
  "credit": "Recorded by CookUp using Surge XT 1.3.4 factory sounds by Claes. Surge output policy: https://surge-synthesizer.github.io/faq/. Multisampled, sustain-looped and level-matched by CookUp; no Surge software or preset files included. No endorsement.",
  "license": {
    "name": "Surge XT audio output policy",
    "url": "https://surge-synthesizer.github.io/faq/"
  },
  "source": {
    "author": "Claes / Surge Synth Team; recordings by CookUp",
    "url": "https://github.com/surge-synthesizer/surge",
    "release": "Surge XT 1.3.4",
    "revision": "f7b97c682ade0b87da85ca5968b63d5c7c98e68d"
  },
  "bitrate": 192,
  "rmsTarget": 0.14,
  "peakCeiling": 0.8,
  "fullStarter": true,
  "renderedSynth": true,
  "instruments": [
    {
      "id": "dx-keys",
      "name": "Studio DX Keys",
      "category": "Keys",
      "sfz": "dx-keys.sfz",
      "tags": [
        "FM",
        "Electric Keys",
        "Bell",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 0.5,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Keys/DX EP.fxp",
        "sha256": "58dce856cd45ed4fc58db9208932180c3bfcb5fe52b74f8b493a943bc778a54d",
        "author": "Claes",
        "name": "DX EP 1"
      },
      "soundProfile": {
        "description": "Sampled FM electric keys; chord voicings, R&B and clean melodic phrases.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          36,
          84
        ],
        "articulation": "decaying",
        "roles": [
          "harmony"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "soft-suitcase",
      "name": "Studio Soft Suitcase",
      "category": "Keys",
      "sfz": "soft-suitcase.sfz",
      "tags": [
        "Soft",
        "Electric Keys",
        "Warm",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 0.4,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Keys/Soft Suitcase.fxp",
        "sha256": "9b366c2aee480a80c0d5bb74bf2f00e45d19161d271f3f5eef6910476b8149aa",
        "author": "Claes",
        "name": "Softsuit"
      },
      "soundProfile": {
        "description": "A soft synthesized keyboard color for intimate harmony and broken chords.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          36,
          84
        ],
        "articulation": "decaying",
        "roles": [
          "harmony"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "glass-bell",
      "name": "Studio Glass Bell",
      "category": "Pluck",
      "sfz": "glass-bell.sfz",
      "tags": [
        "Bell",
        "Glass",
        "Bright",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 0.6,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Plucks/Bell 1.fxp",
        "sha256": "8bb11753f84b7d8e1aa84c805fb4c6e4da471f5e32adc8269321f9297f7d6b6d",
        "author": "Claes",
        "name": "Bell 1"
      },
      "soundProfile": {
        "description": "Clear sampled synth bell for sparse top lines, melodic trap and bright accents.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          48,
          96
        ],
        "articulation": "decaying",
        "roles": [
          "motif"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "fm-pluck",
      "name": "Studio FM Pluck",
      "category": "Pluck",
      "sfz": "fm-pluck.sfz",
      "tags": [
        "FM",
        "Digital",
        "Percussive",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 0.35,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Plucks/FM Pluck.fxp",
        "sha256": "eb1088e29f03b3a5d68194f34b5f173aeda4fd380aa67ce8e232509ec9e8ed06",
        "author": "Claes",
        "name": "FM pluck"
      },
      "soundProfile": {
        "description": "Percussive FM synth pluck for rhythmic motifs and short counter melodies.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          48,
          96
        ],
        "articulation": "decaying",
        "roles": [
          "motif"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "comb-pluck",
      "name": "Studio Comb Pluck",
      "category": "Pluck",
      "sfz": "comb-pluck.sfz",
      "tags": [
        "Resonant",
        "String-like",
        "Percussive",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 0.45,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Plucks/Comb Pluck.fxp",
        "sha256": "2b5784f55979729ddfaabffbb51214162bd6e2647e670369ea964a89f8bb347e",
        "author": "Claes",
        "name": "Combpluck"
      },
      "soundProfile": {
        "description": "A resonant string-like synthesized pluck for articulated riffs and contrasting answers.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          48,
          96
        ],
        "articulation": "decaying",
        "roles": [
          "motif"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "diamonds",
      "name": "Studio Diamonds",
      "category": "Pluck",
      "sfz": "diamonds.sfz",
      "tags": [
        "Sparkle",
        "Digital",
        "Pluck",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 0.5,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Plucks/Diamonds.fxp",
        "sha256": "ca7a3eb9a98c383894a363d213ef1704ea5ae0b22c9caebb34ed8f4f6b2a8285",
        "author": "Claes",
        "name": "Diamonds"
      },
      "soundProfile": {
        "description": "A sparkling sampled synth accent for open melodic arrangements.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          48,
          96
        ],
        "articulation": "decaying",
        "roles": [
          "motif"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "warm-poly-pad",
      "name": "Studio Warm Poly Pad",
      "category": "Pad",
      "sfz": "warm-poly-pad.sfz",
      "tags": [
        "Warm",
        "Analog-style",
        "Sustained",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 1.8,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Pads/MKS-70 Warm Pad.fxp",
        "sha256": "7279cb303a4e21bc7e2617254e3158253898995e94015896d71c4482da5be357",
        "author": "Claes",
        "name": "Buggy Brass"
      },
      "soundProfile": {
        "description": "Warm polyphonic synth pad with recorded stereo movement and a prepared sustain loop.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          36,
          84
        ],
        "articulation": "sustained",
        "roles": [
          "harmony"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "bell-pad",
      "name": "Studio Bell Pad",
      "category": "Pad",
      "sfz": "bell-pad.sfz",
      "tags": [
        "Bell",
        "Airy",
        "Sustained",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 1.6,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Pads/Bell Pad.fxp",
        "sha256": "530296d4697c601f24955b1b5f88e510e7eab3ae1034e31418de4a3bda9920ab",
        "author": "Claes",
        "name": "Bell pad"
      },
      "soundProfile": {
        "description": "A glassy sustained pad for spacious harmony and restrained upper layers.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          36,
          84
        ],
        "articulation": "sustained",
        "roles": [
          "harmony"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "retro-choir",
      "name": "Studio Retro Choir",
      "category": "Pad",
      "sfz": "retro-choir.sfz",
      "tags": [
        "Choir",
        "Vocal",
        "Retro",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 1.6,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Pads/Retro Choir.fxp",
        "sha256": "be2ac10499bf8879148f801fa541270d829bc562cef009d41d3610be086c8f8e",
        "author": "Claes",
        "name": "Retrochoir"
      },
      "soundProfile": {
        "description": "A synthetic choir texture for held voicings and atmospheric supporting layers.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          36,
          84
        ],
        "articulation": "sustained",
        "roles": [
          "harmony"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "winter-pad",
      "name": "Studio Winter Pad",
      "category": "Pad",
      "sfz": "winter-pad.sfz",
      "tags": [
        "Warm",
        "Evolving",
        "Sustained",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 1.8,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Pads/Winter Warmer.fxp",
        "sha256": "a96f81733a68eb89740fab72bf3cc56a4c4481a5cf59c1ac59a394e6f86606e2",
        "author": "Claes",
        "name": "Winter warmer"
      },
      "soundProfile": {
        "description": "A recorded evolving synth pad for slow harmonic movement and background depth.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          36,
          84
        ],
        "articulation": "sustained",
        "roles": [
          "harmony"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "classic-lead",
      "name": "Studio Classic Lead",
      "category": "Lead",
      "sfz": "classic-lead.sfz",
      "tags": [
        "Classic",
        "Analog-style",
        "Lead",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 0.25,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Leads/Classic Lead 1.fxp",
        "sha256": "01e5d0f3e6ea542b50b0d98aeb0ac4e229b7296535e993dc456230b36e1ac204",
        "author": "Claes",
        "name": "Classic lead 1"
      },
      "soundProfile": {
        "description": "A focused classic synth lead captured across pitches and velocities for clear hooks.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          48,
          84
        ],
        "articulation": "sustained",
        "roles": [
          "lead"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "butter-lead",
      "name": "Studio Butter Lead",
      "category": "Lead",
      "sfz": "butter-lead.sfz",
      "tags": [
        "Smooth",
        "Warm",
        "Lead",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 0.3,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Leads/Butter.fxp",
        "sha256": "67a5f29ae842f3119548f818e0be62acbe58fbbf73a21739bd0827c1f9c23ddb",
        "author": "Claes",
        "name": "Butter"
      },
      "soundProfile": {
        "description": "A smooth sampled lead for connected melodic lines; source-synth glide is not captured.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          48,
          84
        ],
        "articulation": "sustained",
        "roles": [
          "lead"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "pwm-lead",
      "name": "Studio PWM Lead",
      "category": "Lead",
      "sfz": "pwm-lead.sfz",
      "tags": [
        "PWM",
        "Bright",
        "Lead",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 0.2,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Leads/Crisp PWM.fxp",
        "sha256": "d4e9369a01982cff11fdca4e74211685ea27956ff0fce89be55665897b7a3ad7",
        "author": "Claes",
        "name": "Crisp PWM"
      },
      "soundProfile": {
        "description": "A crisp pulse-width synth lead with recorded movement for energetic phrases.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          48,
          84
        ],
        "articulation": "sustained",
        "roles": [
          "lead"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "smooth-bass",
      "name": "Studio Smooth Bass",
      "category": "Bass",
      "sfz": "smooth-bass.sfz",
      "tags": [
        "Smooth",
        "Synth Bass",
        "Centered",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 0.16,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Basses/Smoothie.fxp",
        "sha256": "788d6e55bd6e619b9adecbce391063034e6cdab2a0d5a682249c07dc06ce2f4c",
        "author": "Claes",
        "name": "Smootie"
      },
      "soundProfile": {
        "description": "A smooth electronic bass instrument for low melodic phrases; not an 808 drum sample.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          24,
          60
        ],
        "articulation": "sustained",
        "roles": [
          "bass"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "rubber-bass",
      "name": "Studio Rubber Bass",
      "category": "Bass",
      "sfz": "rubber-bass.sfz",
      "tags": [
        "Rubber",
        "Synth Bass",
        "Rhythmic",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 0.12,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Basses/Rubber Bass.fxp",
        "sha256": "efffde06312df7406b440fd5f19f10aab8c92a69d96a020a6231b5f97eb28b13",
        "author": "Claes",
        "name": "Rubber bass"
      },
      "soundProfile": {
        "description": "A rounded rubbery synth bass color for short syncopated riffs.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          24,
          60
        ],
        "articulation": "sustained",
        "roles": [
          "bass"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    },
    {
      "id": "fm-bass",
      "name": "Studio FM Bass",
      "category": "Bass",
      "sfz": "fm-bass.sfz",
      "tags": [
        "FM",
        "Synth Bass",
        "Digital",
        "Synth",
        "Rendered Synth",
        "Studio Synths",
        "Multisampled"
      ],
      "release": 0.15,
      "reverb": 0,
      "humanize": 0,
      "renderedSynth": true,
      "sourcePatch": {
        "path": "Basses/FM Bass 1.fxp",
        "sha256": "3ff338f9d5098489284d56347cf126388d1c5f45f74ebe9f27d9e31704fb6e41",
        "author": "Claes",
        "name": "FM bass 1"
      },
      "soundProfile": {
        "description": "A digital FM bass instrument with clear upper partials for electronic grooves.",
        "descriptionSource": "source-preset-and-recording-design",
        "register": [
          24,
          60
        ],
        "articulation": "sustained",
        "roles": [
          "bass"
        ],
        "macros": [],
        "source": "rendered-synth",
        "sourceEngine": "Surge XT 1.3.4",
        "bank": "CookUp Studio Synths",
        "listeningVerified": false,
        "limitations": "Recorded synth. Original oscillators, modulation, effects and glide are baked into the audio. Native Instrument playback controls remain editable; this is not the full Surge XT engine."
      }
    }
  ]
};
